<template>
  <div
    class="pl-6 b-counterparty-list__item"
    @click="chooseAsset(item)"
    :class="{'active' : getCurrentAssetIdInDB === item.idInDB}"
  >
    <div class="py-3 b-counterparty-list__item-inner">
      <div class="mb-1 b-counterparty-list__title">{{item.name}}</div>
      <div class="b-counterparty-list__info-wrap">
        <div v-if="item.idInDB" class="mr-4 b-counterparty-list__info">
          <div class="mr-2 b-counterparty-list__info-name">id:</div>
          <div class="b-counterparty-list__info-value">{{item.idInDB}}</div>
        </div>
        <div v-if="item.underlyingAssetTypeId" class="b-counterparty-list__info">
          <div class="mr-2 b-counterparty-list__info-name">{{$t('CONTENT.assets.base_type')}}:</div>
          <div class="b-counterparty-list__info-value">{{getAssetType(item.underlyingAssetTypeId)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

	export default {
		props: {
			item: {
				required: true,
        type: Object
			},
    },
    computed: {
      ...mapGetters(['getCurrentAssetIdInDB']),
      ...mapGetters(['getUnderlyingAssetTypes']),
    },
    methods: {
			getAssetType(assetTypeId) {
				for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
					if(this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
						return this.getUnderlyingAssetTypes[i].name;
					}
				}
			},
			chooseAsset(item) {
				this.$store.commit('SET_CURRENT_ASSET_ID', item.idInDB);
      }
    }
	}
</script>

<style scoped>
</style>
